<div class="card width100 logo">
  <div *ngIf="reportSent == 2">
    <conclusion></conclusion>
  </div>
  <div *ngIf="reportSent !== 2">
    <div class="pad-left pad-top">
         <div class="header-text">Summary of Your Results</div>
         <div class="subheader-text">Congratulations on completing the Sustainability Accelerator Tool!</div>
    </div>
    <div class="pad-left pad-top">
      <div class="subheader-subline">
        Upon reviewing your responses to the questions, your company is currently within the 
        <span style="color: {{overallColor}}">{{overallStage}}</span> 
         Stage.
        <br/><br/>
        {{overallDescription}}
      </div>
    </div>
    <div class="pad-left pad-top">
       <div class="subheader-subline2">
         Snapshot Of Your Results Across the 4 Pillars
       </div>
    </div>
    <div class="pad-left pad-top row">
       <div class="column2b">
         <div class="pillar-header">
           Pillar 1<br/>Governance Framework
         </div>
         <div>
           <img class="score-image" src="{{pillar1Score}}">
         </div>       
         <div class="subheader-subline-inner">
           <span style="color: {{pillar1Color}}">{{pillar1Stage.toUpperCase()}}</span> 
         </div>
       </div>
       <div class="column2b">
         <div class="pillar-header">
           Pillar 2<br/>Sustainability Strategy
         </div>
         <div>
           <img class="score-image" src="{{pillar2Score}}">
         </div>
         <div class="subheader-subline-inner">
           <span style="color: {{pillar2Color}}">{{pillar2Stage.toUpperCase()}}</span> 
         </div>
       </div>
       <div class="column2b">
         <div class="pillar-header">
           Pillar 3<br/>Risk &amp; Opportunities
         </div>
         <div>
           <img class="score-image" src="{{pillar3Score}}">
         </div>
         <div class="subheader-subline-inner">
           <span style="color: {{pillar3Color}}">{{pillar3Stage.toUpperCase()}}</span> 
         </div>
       </div>
       <div class="column2b">
         <div class="pillar-header">
           Pillar 4<br/>Metrics &amp; Targets
         </div>
         <div>
           <img class="score-image" src="{{pillar4Score}}">
         </div>
         <div class="subheader-subline-inner">
           <span style="color: {{pillar4Color}}">{{pillar4Stage.toUpperCase()}}</span> 
         </div>
       </div>
    </div>
    <div class="pad-left-more pad-top-more pad-bottom">
       <div class="row2">
         <div class="subheader-text4 column5a1">
           <button *ngIf="reportSent > 2" class="email-button-disabled" disabled="true">REPORT SENT</button>
           <button *ngIf="reportSent == 1" class="email-button">SENDING</button>
           <button *ngIf="reportSent == 0" class="email-button" (click)="mailReport()">SEND REPORT</button>
         </div>
         <div *ngIf="reportSent > 1" class="subheader-text4 column5a2">
           Please check your business email inbox for your personalised report
         </div>
         <div *ngIf="reportSent == 1" class="subheader-text4 column5a2">
           Your personalised report is being sent to your business email inbox
         </div>
         <div *ngIf="reportSent == 0" class="subheader-text4 column5a2">
           Click to get the full report sent to your business email address.
         </div>
       </div>
    </div>
    <div class="pad-left pad-top">
       <div class="subheader-subline4">
         Get in Touch
       </div>
    </div>
    <div class="pad-left pad-top">
       <div class="row">
         <div class="subheader-subline3 column7a">
           <img class="logo" src="assets/images/welcome7.jpg">
         </div>
         <div class="subheader-subline3 column7b">
           Keen to embark on your sustainability journey? Let us know <a target=_blank href="https://www.dbs.com.sg/sme/dbs-forms/sustainability-for-smes?pk_source=typed&pk_medium=direct&pk_campaign=bookmarked">here</a> or contact Deloitte at <a href="mailto: seasustainability@deloitte.com">seasustainability&#64;deloitte.com</a> for customised advisory support.
           <br/><br/>
           Reach out to your relationship manager to find out more about our <a target=_blank href="https://www.dbs.com.sg/sme/sustainability?pk_source=bing&pk_medium=organic&pk_campaign=seo">Sustainable Financing options</a> or explore more on our <a target=_blank href="https://www.dbs.com.sg/sme/default.page?pk_source=typed&pk_medium=direct&pk_campaign=bookmarked">SME Banking website</a>.
         </div>
       </div>
    </div>
    <div class="pad-left pad-top">
       <div class="row">
         <div class="subheader-subline3 column6a">
           <img class="logo" src="assets/images/welcome6.jpg">
         </div>
         <div class="subheader-subline3 column6b">
           The Sustainability Accelerator Tool is developed in partnership with Deloitte Singapore
         </div>
       </div>
    </div>
  </div>
</div>
